import React from 'react';

// Top-level guard — without it any render throw blanks the whole SPA.
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ fontFamily: 'sans-serif', textAlign: 'center', padding: '80px 24px' }}>
        <h2 style={{ margin: '0 0 12px' }}>😥 頁面發生錯誤</h2>
        <p style={{ color: '#6b7280', margin: '0 0 24px' }}>請重新整理頁面，或返回首頁再試一次。</p>
        <button
          onClick={() => { window.location.href = '/'; }}
          style={{ padding: '10px 28px', borderRadius: 10, border: 'none', background: '#f59e0b',
                   color: 'white', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}>
          返回首頁
        </button>
      </div>
    );
  }
}
